import "./rectangle.scss";
import React from "react";

function Rectangle(props) {
  const { title, key, onClick = () => {}, className = `` } = props;
  return (
    <div className={`rectangle ${className}`} key={key} onClick={onClick}>
      {title}
    </div>
  );
}

export default Rectangle;
